import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
import { LoaderService } from '../services/LoaderService/loader.service';
import { API_ENDPOINTS } from '../http/api-end-points';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

    private totalRequests = 0;

    constructor(private loadingService: LoaderService) { }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const licenseUploaded = JSON.parse(localStorage.getItem('licenseUploaded') || 'false');

        const isSignInApi = request.url.includes('sign-in');
        const handshake = request.url.includes('client-handshake');
        const chat_bot_api = [API_ENDPOINTS.AI_CHATBOT.FA2_ANALYSIS, API_ENDPOINTS.BUG_DETAIL_CHATBOT.CONVERSATION, API_ENDPOINTS.CRASH_DETAIL_CHATBOT.CONVERSATION, API_ENDPOINTS.SURVEY_CHATBOT.CREATION.RECOMMEND, API_ENDPOINTS.SURVEY_CHATBOT.CREATION.CLARIFY, API_ENDPOINTS.SURVEY_CHATBOT.CREATION.GENRATE_SURVEY];
        // ✅ If it's sign-in API and licenseUploaded is true → skip loader
        if (isSignInApi && licenseUploaded) {
            this.loadingService.hide();
            return next.handle(request);
        } else if (chat_bot_api.some(api => request.url.includes(api))) {
            this.loadingService.hide();
            return next.handle(request);
        }
        else if (handshake && licenseUploaded) {
            this.loadingService.hide();
            return next.handle(request);
        } else if (chat_bot_api.some(api => request.url.includes(api))) {
            this.loadingService.hide();
            return next.handle(request);
        }
        else {

            // ✅ Else normal loader behavior
            this.totalRequests++;
            this.loadingService.show();

            return next.handle(request).pipe(
                finalize(() => {
                    this.totalRequests--;
                    if (this.totalRequests === 0) {
                        this.loadingService.hide();
                    }
                })
            );
        }
    }
}
